module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-00.469f83ee.png";